'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handlers = {

  /* Flyout toggle. */
  flyout: function flyout($dom, gn) {
    $dom.flyoutBtn.on('click', function () {
      return gn.toggleFlyout();
    });
    $dom.mask.on('click', function () {
      if ($dom.mask.hasClass(_constants.DOM_CLASSES.maskFlyoutOpen)) {
        gn.toggleFlyout();
      }
    });
  },


  /* Window handler functions. */
  window: function window($dom) {
    $dom.window.on('click', function () {
      if ($dom.userInfo.hasClass(_constants.DOM_CLASSES.userInfoOpen)) {
        $dom.userInfo.removeClass(_constants.DOM_CLASSES.userInfoOpen);
      }
    });
  },


  /* User information box toggle. */
  user: function user($dom) {
    $dom.userInfoBtn.on('click', function (evt) {
      $dom.userInfo.toggleClass(_constants.DOM_CLASSES.userInfoOpen);
      evt.stopPropagation();
    });
    $dom.userInfo.on('click', function (evt) {
      evt.stopPropagation();
    });
  },


  /* Search toggle handlers. */
  search: function search($dom, gn) {
    $dom.searchBtn.on('click', function () {
      gn.showSearch();
    });
    $dom.searchInput.on('blur', function () {
      gn.hideSearch();
    });
    $dom.searchTopSites.on('mousedown', function () {
      window.location = $dom.searchTopSites.attr('href');
    });
  },


  /* Nav section click handlers. */
  sections: function sections($dom) {
    $dom.sections.each(function () {
      /* Removing this to prevent people from intercepting clicks unnecessarily.
      const $section = $(section);
      $section.on('click', (evt) => {
        const item = {
          type: 'section',
          data: config.parameters.sections[config.parameters.product].sections[$section.data('section')]
        };
        config.observers.forEach((obs) => {
          obs(evt, item);
        });
      });
      */
    });
  },
  selector: function selector($dom, gn, config) {
    $dom.accountSelectorBtn.on('click', function () {
      gn.showAccountSelector();
    });
    $dom.accountSelectorExit.on('click', function () {
      gn.hideAccountSelector();
    });
    $dom.accountSelectorSearchInput.on('click paste keyup', function (evt) {
      gn.filterAccounts(evt.target.value);
    });
    this.selectorAccountsList($dom, gn, config);
  },


  /* Open account selector when it is clicked, and close it when the x is clicked. */
  selectorAccountsList: function selectorAccountsList($dom, gn, config) {
    $dom.accountSelectorItem.on('click', function (evt) {
      gn.hideAccountSelector();
      var pCode = (0, _jquery2.default)(evt.currentTarget).data('pcode');
      var rtbid = (0, _jquery2.default)(evt.currentTarget).data('rtbid');
      gn.setContext({ pCode: pCode, rtbid: rtbid });
      gn.refreshSection({ pCode: pCode, rtbid: rtbid });
      gn.getAccounts().then(function (accounts) {
        var newAccount = accounts.find(function (account) {
          return account.pCode === pCode;
        });
        var item = { type: 'account', data: newAccount };
        config.observers.forEach(function (obs) {
          obs(evt, item);
        });
      });
    });
  }
};

exports.default = handlers;


//////////////////
// WEBPACK FOOTER
// ./node_modules/qc-global-navigation/src/handlers.js
// module id = 198
// module chunks = 0